import React, {useRef} from 'react';
import {gsap} from "gsap";
import {useGSAP} from "@gsap/react";
function MaterialButton({ children }) {

	const button = useRef(null);
	const ripple = useRef(null);
	const tween = useRef(null);

	useGSAP(() => {
		tween.current = gsap.to(ripple.current, { scale: 4, duration: 0.5, paused: true});

	}, []);

	const onEnter = () => {
		tween.current.play();
	};

	const onLeave = () => {
		tween.current.reverse();
	};

	return (
		<button className="btn-ripple" ref={button} onMouseEnter={onEnter} onMouseLeave={onLeave}>
			<div className="btn-ripple__text">{children}</div>
			<div className="btn-ripple__ripple" ref={ripple}></div>
		</button>
	);
}

export default MaterialButton;
